// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.values-section {
  padding: 120px 0;
  margin-bottom: 150px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}
@media (max-width: 1023px) {
  .values-section {
    margin: 96px 0;
    padding: 96px 0;
  }
}
@media (min-width: 820px) and (max-width: 1023px) {
  .values-section {
    padding: 96px 0;
    margin-bottom: 96px;
    margin-top: 0px;
  }
}
.values-section .container {
  position: relative;
  z-index: 2;
}
.values-section .values-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}
@media (min-width: 1024px) and (max-width: 1200px) {
  .values-section .values-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
}
@media (max-width: 1023px) {
  .values-section .values-grid {
    gap: 16px;
  }
}
.values-section .values-intro {
  grid-column: 1;
  color: #fff;
  padding-right: 40px;
}
.values-section .values-intro h2 {
  font-size: 52px;
  font-weight: 700;
  margin-bottom: 30px;
  line-height: 1.2;
  padding-top: 20px;
}
@media (max-width: 1023px) {
  .values-section .values-intro h2 {
    font-size: 40px !important;
    margin-bottom: 25px !important;
    padding-top: 0px;
  }
}
.values-section .values-intro p {
  font-size: 18px;
  font-weight: 300;
  line-height: 26px;
  font-weight: 400;
  opacity: 1;
  color: #F2F3F3;
}
.values-section .values-card {
  background-color: #fff;
  border-radius: 10px;
  padding: 40px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.values-section .values-card .card-icon {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #E3DBD8;
  margin-bottom: 30px;
  transition: all 0.3s ease;
}
.values-section .values-card .card-icon img {
  width: 45px;
  height: 45px;
  object-fit: contain;
}
.values-section .values-card h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #283583;
  transition: color 0.3s ease;
}
.values-section .values-card p {
  font-size: 16px;
  line-height: 1.6;
  font-weight: 400;
  line-height: 24px;
  color: #727272;
}
@media (min-width: 1200px) {
  .values-section .values-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  }
  .values-section .values-card:hover .card-icon {
    background-color: rgba(0, 68, 129, 0.05);
    border: 1px solid rgba(0, 68, 129, 0.05);
  }
  .values-section .values-card:hover h3 {
    color: #004481;
  }
}
@media (max-width: 1023px) {
  .values-section .values-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .values-section .values-intro {
    grid-column: 1/-1;
    grid-row: 1;
    text-align: left;
    padding-right: 0;
    margin-bottom: 30px;
  }
  .values-section .values-card {
    text-align: left;
  }
  .values-section .values-card .card-icon {
    margin: 0 0 20px;
  }
}
@media (max-width: 767px) {
  .values-section .values-grid {
    grid-template-columns: 1fr;
  }
  .values-section .values-intro {
    text-align: left;
  }
  .values-section .values-intro h2 {
    font-size: 36px;
  }
  .values-section .values-card {
    padding: 40px;
    text-align: left;
  }
  .values-section .values-card .card-icon {
    margin: 0 0 25px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/values/Values.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EATJ;IAUQ,cAAA;IACA,eAAA;EAEN;AACF;AAAI;EAdJ;IAeQ,eAAA;IACA,mBAAA;IACA,eAAA;EAGN;AACF;AADI;EACI,kBAAA;EACA,UAAA;AAGR;AAAI;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AAER;AAAQ;EALJ;IAMQ,aAAA;IACA,qCAAA;IACA,SAAA;EAGV;AACF;AADQ;EAXJ;IAYQ,SAAA;EAIV;AACF;AADI;EACI,cAAA;EACA,WAAA;EACA,mBAAA;AAGR;AADQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAGZ;AADY;EAPJ;IAQQ,0BAAA;IACA,8BAAA;IACA,gBAAA;EAId;AACF;AADQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AAGZ;AACI;EACI,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,yBAAA;AACR;AACQ;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AACZ;AACY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAChB;AAGQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;AADZ;AAIQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAFZ;AAOI;EACI;IACI,4BAAA;IACA,2CAAA;EALV;EAOU;IACI,wCAAA;IACA,wCAAA;EALd;EAQU;IACI,cAAA;EANd;AACF;AAWI;EACI;IACI,qCAAA;EATV;EAYM;IACI,iBAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;EAVV;EAaM;IACI,gBAAA;EAXV;EAaU;IACI,gBAAA;EAXd;AACF;AAgBI;EAEI;IACI,0BAAA;EAfV;EAkBM;IACI,gBAAA;EAhBV;EAiBU;IACI,eAAA;EAfd;EAmBM;IACI,aAAA;IACA,gBAAA;EAjBV;EAmBU;IACI,kBAAA;EAjBd;AACF","sourcesContent":[".values-section {\n    padding: 120px 0;\n    margin-bottom: 150px;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    position: relative;\n    overflow: hidden;\n\n    @media (max-width: 1023px) {\n        margin: 96px 0;\n        padding: 96px 0;\n    }\n\n    @media (min-width: 820px) and (max-width: 1023px) {\n        padding: 96px 0;\n        margin-bottom: 96px;\n        margin-top: 0px;\n    }\n    \n    .container {\n        position: relative;\n        z-index: 2;\n    }\n    \n    .values-grid {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap: 30px;\n\n        @media (min-width: 1024px) and (max-width: 1200px) {\n            display: grid;\n            grid-template-columns: repeat(2, 1fr);\n            gap: 30px;\n        }\n\n        @media (max-width: 1023px) {\n            gap: 16px;\n        }\n    }\n    \n    .values-intro {\n        grid-column: 1;\n        color: #fff;\n        padding-right: 40px;\n        \n        h2 {\n            font-size: 52px;\n            font-weight: 700;\n            margin-bottom: 30px;\n            line-height: 1.2;\n            padding-top: 20px;\n\n            @media (max-width: 1023px) {\n                font-size: 40px !important;\n                margin-bottom: 25px !important;\n                padding-top: 0px;\n            }\n        }\n        \n        p {\n            font-size: 18px;\n            font-weight: 300;\n            line-height: 26px;\n            font-weight: 400;\n            opacity: 1;\n            color: #F2F3F3;\n        }\n    }\n    \n    .values-card {\n        background-color: #fff;\n        border-radius: 10px;\n        padding: 40px;\n        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n        transition: all 0.3s ease;\n        \n        .card-icon {\n            width: 100px;\n            height: 100px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 50%;\n            border: 1px solid #E3DBD8;\n            margin-bottom: 30px;\n            transition: all 0.3s ease;\n            \n            img {\n                width: 45px;\n                height: 45px;\n                object-fit: contain;\n            }\n        }\n        \n        h3 {\n            font-size: 22px;\n            font-weight: 700;\n            margin-bottom: 20px;\n            color: #283583;\n            transition: color 0.3s ease;\n        }\n        \n        p {\n            font-size: 16px;\n            line-height: 1.6;\n            font-weight: 400;\n            line-height: 24px;\n            color: #727272;\n        }\n    }\n    \n    // Tablet ve üzeri için hover efektleri\n    @media (min-width: 1200px) {\n        .values-card:hover {\n            transform: translateY(-10px);\n            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);\n            \n            .card-icon {\n                background-color: rgba(0, 68, 129, 0.05);\n                border: 1px solid rgba(0, 68, 129, 0.05);;\n            }\n            \n            h3 {\n                color: #004481;\n            }\n        }\n    }\n    \n    // Tablet\n    @media (max-width: 1023px) {\n        .values-grid {\n            grid-template-columns: repeat(2, 1fr);\n        }\n        \n        .values-intro {\n            grid-column: 1 / -1;\n            grid-row: 1;\n            text-align: left;\n            padding-right: 0;\n            margin-bottom: 30px;\n        }\n        \n        .values-card {\n            text-align: left;\n            \n            .card-icon {\n                margin: 0 0 20px;\n            }\n        }\n    }\n    \n    // Mobil\n    @media (max-width: 767px) {\n        \n        .values-grid {\n            grid-template-columns: 1fr;\n        }\n        \n        .values-intro {\n            text-align: left;\n            h2 {\n                font-size: 36px;\n            }\n        }\n        \n        .values-card {\n            padding: 40px;\n            text-align: left;\n\n            .card-icon {\n                margin: 0 0 25px 0;\n            }\n        }\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
